module.exports = __webpack_public_path__ + "media/images/mobile-beta-app-c35ef2ec791229f4c8883479bf3060a7.png";